import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/h5/poster-long-1.jpg'
import _imports_1 from '@/assets/h5/poster-long-2.jpg'
import _imports_2 from '@/assets/h5/poster1-top.png'
import _imports_3 from '@/assets/h5/poster2-top.png'
import _imports_4 from '@/assets/h5/poster2-line.png'
import _imports_5 from '@/assets/h5/poster1-bottom.png'
import _imports_6 from '@/assets/h5/poster2-bottom.png'
import _imports_7 from '@/assets/logo_white.png'


const _withScopeId = n => (_pushScopeId("data-v-f382b2e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "poster-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "poster-wrap_title" }, "选择分享海报模板", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_5 = { class: "custom-indicator" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("生成海报")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("长按图片可保存或分享")
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "bg",
  src: _imports_2
}
const _hoisted_10 = {
  key: 1,
  class: "bg",
  src: _imports_3
}
const _hoisted_11 = {
  key: 0,
  class: "poster2-line__left",
  src: _imports_4,
  alt: ""
}
const _hoisted_12 = {
  key: 1,
  class: "poster2-line__right",
  src: _imports_4,
  alt: ""
}
const _hoisted_13 = { class: "post-item__title" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "招聘人数：", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工作经验：", -1))
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "学历要求：", -1))
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工作地点：", -1))
const _hoisted_21 = { key: 3 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工作地址：", -1))
const _hoisted_23 = { key: 4 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系人：", -1))
const _hoisted_25 = { key: 5 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电话：", -1))
const _hoisted_27 = { style: {"margin-right":"0.2rem"} }
const _hoisted_28 = {
  key: 2,
  class: "bg",
  src: _imports_5
}
const _hoisted_29 = {
  key: 3,
  class: "bg",
  src: _imports_6
}
const _hoisted_30 = { class: "poster-qrcode" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "poster-qrcode__logo"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_notify = _resolveComponent("van-notify")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_swipe, {
      class: "poster-swipe",
      "indicator-color": "white",
      "lazy-render": "",
      onChange: _ctx.handleSwiperChange
    }, {
      indicator: _withCtx(({ active, total }) => [
        _createElementVNode("div", _hoisted_5, _toDisplayString(active + 1) + "/" + _toDisplayString(total), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_van_swipe_item, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_van_swipe_item, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onChange"]),
    _createVNode(_component_van_button, {
      class: "poster-button",
      color: "#5D89FF",
      block: "",
      round: "",
      onClick: _ctx.handlePosterSelect
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.imgUrl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "image-wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePosterClose && _ctx.handlePosterClose(...args)))
        }, [
          _createVNode(_component_van_notify, {
            show: _ctx.imgUrl,
            "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imgUrl) = $event)),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["show"]),
          _createElementVNode("img", { src: _ctx.imgUrl }, null, 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref: "imageRef",
      class: _normalizeClass(['image-dom', { isLight: _ctx.activeSwiper == 1 }])
    }, [
      (_ctx.activeSwiper == 0)
        ? (_openBlock(), _createElementBlock("img", _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.activeSwiper == 1)
        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "post-item",
            key: index
          }, [
            (_ctx.activeSwiper == 1 && index != 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
              : _createCommentVNode("", true),
            (_ctx.activeSwiper == 1 && index != 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_12))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, "0" + _toDisplayString(index + 1) + ". " + _toDisplayString(item.postNameOut), 1),
            _createElementVNode("ul", {
              class: _normalizeClass(`ul_${_ctx.activeSwiper}`)
            }, [
              (item.channelId == 3)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(item.demandNumOut), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(item.requireAgeName), 1)
              ]),
              (item.channelId != 3)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(item.educationName), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.channelId != 3)
                ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(item.workPlaceNameStr && item.workPlaceNameStr.split('-')[1]), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.channelId == 3)
                ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                    _hoisted_22,
                    _createTextVNode(" " + _toDisplayString(item.workPlaceNameStr && item.workPlaceNameStr.split('-')[0]) + "-" + _toDisplayString(item.workPlaceDetail), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.channelId == 3 && item.contactUserName)
                ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(item.contactUserName), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.channelId == 3 && (item.contactUserPhone || item.contactUserLandline))
                ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("span", _hoisted_27, _toDisplayString(item.contactUserPhone), 1),
                    _createElementVNode("span", null, _toDisplayString(item.contactUserLandline), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        }), 128))
      ]),
      (_ctx.activeSwiper == 0)
        ? (_openBlock(), _createElementBlock("img", _hoisted_28))
        : _createCommentVNode("", true),
      (_ctx.activeSwiper == 1)
        ? (_openBlock(), _createElementBlock("img", _hoisted_29))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("img", {
          src: _ctx.qrcode,
          class: "poster-qrcode__img"
        }, null, 8, _hoisted_31),
        _hoisted_32
      ])
    ], 2)
  ]))
}